import {useEffect, useState} from "react";
import utils from "../utils/DateUtils";
import PdfDocument from "./PdfDocument";
import info_img from "../assets/info.png";
import ValuationInfoPopup from "./ValuationInfoPopup";
import val_api from "../api/valuation";

const FinviseValuation = (props) => {

    const GENERATING = 13
    const GENERATED = 14
    const FAILED = 15

    // Report Data
    const [valuation, setValuation] = useState();
    const [valuationId, setValuationId] = useState();
    const [processedDate, setProcessedDate] = useState();
    const [furtherDetails, setFurtherDetails] = useState();
    const [showInfoPanel, setShowInfoPanel] = useState(false);

    const [lastTransaction, setLastTransaction] = useState(false);
    const [showValuation, setShowValuation] = useState(false)
    const [showAccuracy, setShowAccuracy] = useState(false)

    const [reportReady, setReportReady] = useState(false);
    const [reportFailed, setReportFailed] = useState(false);

    const [degrees, setDegrees] = useState(0);

    // Error Showing
    const setError = props.setError
    const setShowErrorDialog = props.setShowErrorDialog

    useEffect(() => {
        if (!degrees) return
        let elements = document.getElementsByClassName("actual-degree");
        if (!elements) return;
        // Set graph
        for (let i=0;i<elements.length;i++){
            elements[i].style.setProperty('--final-degree', degrees + 'deg');
        }
    }, [degrees])

    useEffect(() => {
        setValuation(props.valuation)
        setValuationId(props.valuationId)
        setProcessedDate(props.processedDate)
        for (let i=0;i < props.furtherDetails.length;i++) {
            if (props.furtherDetails[i].title === "Japanese Knotweed") {
                let _value = ""
                if (props.furtherDetails[i].value && props.furtherDetails[i].value >= 99) {
                    _value = "Category A: Action"
                } else if (95 <= props.furtherDetails[i].value && props.furtherDetails[i].value < 99) {
                    _value = "Category B: Action"
                } else if (80 <= props.furtherDetails[i].value && props.furtherDetails[i].value < 95) {
                    _value = "Category C: Action"
                } else if (props.furtherDetails[i].value && props.furtherDetails[i].value < 80) {
                    _value = "Category D: Action"
                } else {
                    _value = "-"
                }
                props.furtherDetails[i].value = _value
            }
        }
        setFurtherDetails(props.furtherDetails)
    }, [props.valuation, props.valuationId, props.processedDate, props.furtherDetails])

    useEffect(() => {
        if (!props.valuationId) return
        PDFCheck()
    }, [props.valuationId])

    const PDFCheck = () => {
        if (!props.valuationId) return
        let response = val_api.getPDFStatus(props.valuationId);
        response.then(
            response => {
                if (response.data.report_reference_status && response.data.report_reference_status !== FAILED && response.data.report_reference_status !== GENERATED) {
                    setTimeout(PDFCheck, 5000);
                }
                else if (response.data.report_reference_status && response.data.report_reference_status === GENERATED) {
                    setReportReady(true)
                }
                else {
                    setReportFailed(true)
                }
            }
        ).catch((err) => {
            console.log(err);
        })
    }

    const handleInfoClick = () => {
        setShowInfoPanel(true);
    }

    const updateShowInfo = (show) => {
        setShowInfoPanel(show);
    }

    const handleShowDownloadError = (error) => {
        setError(error);
        setShowErrorDialog(true);
    }

    useEffect(() => {
        if (!valuation) return;
        if (valuation.accuracy !== null) {
            setDegrees(((valuation.accuracy * 10) / 100)  * 135);
            setShowAccuracy(true)
        }
        if (valuation.predicted_valuation) setShowValuation(true)
        if (valuation.transaction_date !== undefined && valuation.transaction_date !== null && valuation.transaction_date !== 0 &&
            valuation.predicted_value !== undefined && valuation.predicted_value !== null && valuation.predicted_value !== 0 &&
            valuation.historic_value !== undefined && valuation.historic_value !== null && valuation.historic_value !== 0) {
            setLastTransaction(true)
        }
    }, [valuation])

    return (
        <>
            {valuation ?
                <div className="valuation-result-container">
                    <div className="valuation-result-details">
                        <div className="current-predicted-container">
                            <div className="predicted-value-title">Current Valuation</div>
                            <div className="predicted-value-icon">
                                <img src={info_img} alt="info" onClick={handleInfoClick}/>
                            </div>
                            <div className="current-predicted-data-container">
                                <div className="predicted-value-amount">
                                    {showValuation ?
                                        <>
                                            £{valuation.predicted_valuation.toLocaleString()}
                                        </>
                                        : "Insufficient data"}
                                </div>

                            </div>
                        </div>
                        <div className="last-transaction-container">
                            <div className="predicted-value-title">Confidence</div>
                            <div className="predicted-value-confidence-container">
                                <div className="accuracy-container">
                                    {showAccuracy ?
                                        <div className="circle-wrap">
                                            <div className="circle">
                                                <div className="mask full actual-degree" id="full">
                                                    <div className="fill actual-degree"></div>
                                                </div>
                                                <div className="mask half">
                                                    <div className="fill actual-degree"></div>
                                                </div>
                                                <div className="inside-circle">
                                                    <div className="accuracy-value">{valuation.accuracy}/10</div>
                                                </div>
                                            </div>
                                        </div>
                                        :null}
                                </div>
                                <div className="predicted-value-confidence-data-container">
                                    <div className="predicted-value-data-container">
                                        <div className="predicted-value-data-title">Transaction date</div>
                                        <div className="predicted-value-data-value">{valuation.transaction_date && utils.short_display_date(valuation.transaction_date * 1000) ? utils.short_display_date(valuation.transaction_date * 1000) : "No Data"}</div>
                                    </div>
                                    <div className="predicted-value-data-container">
                                        <div className="predicted-value-data-title">Sale Price</div>
                                        <div className="predicted-value-data-value">{valuation.historic_value && valuation.historic_value.toLocaleString() ? "£" + valuation.historic_value.toLocaleString() : "No Data"}</div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="download-container">
                            <PdfDocument valuation={valuation} id={valuationId}
                                         showError={handleShowDownloadError.bind(this)}
                                         processedDate={processedDate} title={"Your Valuation Report"}
                                         ready={reportReady}
                                         failed={reportFailed}
                                         text={
                                            reportFailed && reportFailed ? "The report has failed generating" :
                                                reportReady && reportReady ? "The full report has been created for you to download." :
                                                    "The report is currently being created and will be ready shortly."
                                         }/>
                        </div>
                    </div>
                    <div className="valuation-details-cards-title">Further Details</div>
                    <div className="valuation-cards">
                        {furtherDetails && furtherDetails.map((card, idx) => {
                            return (
                                <div className="valuation-card" key={idx}>
                                    <div className="valuation-card-icon">
                                        <img src={"/images/valuation/" + card.icon_filename} alt="Valuation Card Icon"/>
                                    </div>
                                    <div className="valuation-card-background">
                                        <img src={"/images/valuation/" + card.background_filename}
                                             alt="Valuation Card Background"/>
                                    </div>
                                    <div className="valuation-card-value">
                                        {card.value && card.value ? card.value : " - "}
                                    </div>
                                    <div className="valuation-card-title">
                                        {card.title}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                : null}
            {showInfoPanel ? <ValuationInfoPopup update={updateShowInfo.bind(this)}/> : null}
        </>
    )
}

export default FinviseValuation